import TableInputField, { getTableInputField } from './TableInputField';

// Builders
import ColumnConfig from './builders/TableInputField.columnConfig';
import CellConfig from './builders/TableInputField.cellConfig';

// Containers
import withTableActions from './containers/withTableActions';
import withHideShowEntries from './containers/withHideShowEntries';
import withAddNewButtonAtBottom from './containers/withAddNewButtonAtBottom';
import withDefaultRow from './containers/withDefaultRow';
export var TableFieldWithActions = withTableActions(TableInputField);
export var getCustomTableFieldWithActions = function getCustomTableFieldWithActions(customTableInputField) {
  return withTableActions(customTableInputField);
};
export { ColumnConfig, CellConfig, getTableInputField, withHideShowEntries, withAddNewButtonAtBottom, withDefaultRow };
export default TableInputField;